import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth } from "./AuthProvider";
import { Navigate, useLocation } from "react-router-dom";
var ProtectedRoute = function (_a) {
    var unauthenticatedRedirect = _a.unauthenticatedRedirect, children = _a.children;
    var authContext = useAuth();
    var location = useLocation();
    if (!(authContext === null || authContext === void 0 ? void 0 : authContext.isSignedIn)) {
        return _jsx(Navigate, { to: unauthenticatedRedirect, replace: true, state: { from: location } });
    }
    return children;
};
export default ProtectedRoute;
